import { Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

function RouteComponent() {
  return <Typography level="h2">Zukünftige Verkehrszeichen-Importe</Typography>;
}

export const Route = createFileRoute('/_authenticated/_management/meine-organisation/importe/')({
  component: RouteComponent,
});
